import Vue from 'vue'
import VueRouter from 'vue-router'

/**
 * @router 场所端
 */
// 选择网吧
import ChooseBar from 'views/ChooseBar.vue'
// 首页
import Home from 'views/Home.vue'
// 登录页面
import Login from 'views/Login.vue'
// 问题保修
import PblmWarranty from 'views/PblmWarranty.vue'
// 填写保修单
import WriteWarranty from 'views/WriteWarranty.vue'
// 保修单详情
import DetailsWarranty from 'views/DetailsWarranty.vue'
// 咨询记录
import ConsultRecords from 'views/ConsultRecords.vue'
// 新建咨询
import ConsultNew from 'views/ConsultNew.vue'
// 咨询详情
import ConsultDetails from 'views/ConsultDetails.vue'
// 搜索常见问题
import Problems from 'views/Problems.vue'
// 关键字搜索
import KeywordSearch from 'views/KeywordSearch.vue'
// 搜索详情
import SearchDetails from 'views/SearchDetails.vue'
// 产品充值
import ProductPay from 'views/ProductPay.vue'
// 支付结果
import ResultPay from 'views/ResultPay.vue'
// 人员核实
import PersonnelVerify from 'views/PersonnelVerify.vue'
// 用户信息
import PersonnelUserInfo from 'views/PersonnelUserInfo.vue'
// 人员培训
import PersonnelInspection from 'views/PersonnelInspection.vue'
// 人员考核
import PersonnelAssess from 'views/PersonnelAssess.vue'
// 答题-题库练习
import Answer from 'views/Answer.vue'
// 模拟考试
import PracticeTest from 'views/PracticeTest.vue'
// 最后一题-题库练习
import AnswerResult from 'views/AnswerResult.vue'
// 考试记录 
import TestRecords from 'views/TestRecords.vue'
// 网吧管理
import NetbarSoftware from 'views/NetbarSoftware.vue'
// 添加人员
import AddUser from 'views/AddUser.vue'
// 网吧信息管理
import InfoManagement from 'views/InfoManagement.vue'
// 搜索经纬度
import SearchMap from 'views/SearchMap.vue'
// 评价
import Evaluation from 'views/Evaluation.vue'
// 巡检评价
import XjEvaluation from 'views/Xjevaluation.vue'
// 用户协议
import Agreement from 'views/Agreement.vue'
// 设备离线
import Devoffline from 'views/Devoffline.vue'
// 咨询详情
import Zxconsultation from 'views/Zxconsultation.vue'
// 通知通报
import Notification from 'views/Notification.vue'
/**
 * @router 运维端 
 */
// 工单处理
import WorkOrderProcess from 'views/WorkOrderProcess.vue'
// 工单详情
import WorkOrderDetails from 'views/WorkOrderDetails.vue'
// 处理完毕
import ProcessMethod from 'views/ProcessMethod.vue'
// 网吧详细信息管理
import CustomerInfo from 'views/CustomerInfo.vue'
// 知识库搜索
import Base from 'views/Base.vue'
// 知识库
import BaseSerch from 'views/BaseSerch.vue'
// 知识库详情
import BaseSearchDetails from 'views/BaseSearchDetails.vue'
// 巡检工单
import InspectionRecords from 'views/InspectionRecords.vue'
// 巡检详情
import InspectionRecordsDetails from 'views/InspectionRecordsDetails.vue'
// 填写巡检单
import Writeinspectionrecords from 'views/Writeinspectionrecords.vue'
// 选择网吧
import SearchInternetCafes from 'views/SearchInternetCafes.vue'
// 客户管理搜索
import CustomerSearch from 'views/CustomerSearch.vue'
// 客户管理备注
import CustomerNote from 'views/CustomerNote.vue'
// 客户管理用户
import CustomerUser from 'views/CustomerUser.vue'

//往期活动详情
import DrawHistoryActivityDetail from 'views/DrawHistoryActivityDetail.vue'
// 往期活动列表
import DrawHistoryActivityList from 'views/DrawHistoryActivityList.vue'
// 下期预告活动
import DrawNextActivityList from 'views/DrawNextActivityList.vue'
// 抽奖活动菜单
import DrawMenu from 'views/DrawMenu.vue'
// 抽奖活动
import DrawActivity from 'views/DrawActivity.vue'
// 抽奖规则
import DrawRule from 'views/drawrule.vue'
// 我的奖品
import MyPrize from 'views/MyPrize.vue'
// 我的积分
import integral from 'views/integral.vue'
// 核对信息
import INFO from 'views/info.vue'
Vue.use(VueRouter)
const routes = [{
    path: '/choosebar',
    name: 'choosebar',
    component: ChooseBar,
    meta: {
      title: '选择网吧',
      requiresAuth: true // 判断是否需要登录
    },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '首页',
      requiresAuth: true // 判断是否需要登录
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/info',
    name: 'info',
    component: INFO,
    meta: {
      title: '核对信息'
    }
  },
  {
    path: '/integral',
    name: 'integral',
    component: integral,
    meta: {
      title: '我的积分'
    }
  },
  {
    path: '/pblmwarranty',
    name: 'pblmwarranty',
    component: PblmWarranty,
    meta: {
      title: '问题报修'
    }
  },
  {
    path: '/writewarranty',
    name: 'writewarranty',
    component: WriteWarranty,
    meta: {
      title: '填写报修单'
    }
  },
  {
    path: '/detailswarranty',
    name: 'detailswarranty',
    component: DetailsWarranty,
    meta: {
      title: '报修详情'
    }
  },
  {
    path: '/myprize',
    name: 'myprize',
    component: MyPrize,
    meta: {
      title: '我的奖品'
    }
  },
  {
    path: '/consultrecords',
    name: 'consultrecords',
    component: ConsultRecords,
    meta: {
      title: '咨询记录'
    }
  },
  {
    path: '/consultnew',
    name: 'consultnew',
    component: ConsultNew,
    meta: {
      title: '新建咨询'
    }
  },
  {
    path: '/consultdetails',
    name: 'consultdetails',
    component: ConsultDetails,
    meta: {
      title: '咨询详情'
    }
  },
  {
    path: '/problems',
    name: 'problems',
    component: Problems,
    meta: {
      title: '常见问题'
    }
  },
  {
    path: '/keywordsearch',
    name: 'keywordsearch',
    component: KeywordSearch,
    meta: {
      title: '常见问题'
    }
  },
  {
    path: '/searchdetails',
    name: 'searchdetails',
    component: SearchDetails,
    meta: {
      title: '问题详情'
    }
  },
  {
    path: '/productpay',
    name: 'productpay',
    component: ProductPay,
    meta: {
      title: '产品充值'
    }
  },
  {
    path: '/resultpay',
    name: 'resultpay',
    component: ResultPay,
    meta: {
      title: '充值结果'
    }
  },
  {
    path: '/personnelverify',
    name: 'personnelverify',
    component: PersonnelVerify,
    meta: {
      title: '人员核实'
    }
  },
  {
    path: '/perosonneluserinfo',
    name: 'perosonneluserinfo',
    component: PersonnelUserInfo,
    meta: {
      title: '用户信息'
    }
  },
  {
    path: '/personnelinspection',
    name: 'personnelinspection',
    component: PersonnelInspection,
    meta: {
      title: '人员培训'
    }
  },
  {
    path: '/personnelassess',
    name: 'personnelassess',
    component: PersonnelAssess,
    meta: {
      title: '人员考核'
    }
  },
  {
    path: '/answer',
    name: 'answer',
    component: Answer,
    meta: {
      title: '答题'
    }
  },
  {
    path: '/practicetest',
    name: 'practicetest',
    component: PracticeTest,
    meta: {
      title: '模拟考试'
    }
  },

  {
    path: '/answerresult',
    name: 'answerresult',
    component: AnswerResult,
    meta: {
      title: '答题结果'
    }
  },
  {
    path: '/testrecords',
    name: 'testrecords',
    component: TestRecords,
    meta: {
      title: '考试记录'
    }
  },
  {
    path: '/netbarsoftware',
    name: 'netbarsoftware',
    component: NetbarSoftware,
    meta: {
      title: '网吧管理'
    }
  },
  {
    path: '/drawactivity',
    name: 'drawactivity',
    component: DrawActivity,
    meta: {
      title: '抽奖活动'
    }
  },
  {
    path: '/draw_menu',
    name: 'draw_menu',
    component: DrawMenu,
    meta: {
      title: '抽奖活动'
    }
  },
  {
    path: '/NextActivityList',
    name: 'NextActivityList',
    component: DrawNextActivityList,
    meta: {
      title: '下期预告'
    }
  },
  {
    path: '/HistoryActivityList',
    name: 'HistoryActivityList',
    component: DrawHistoryActivityList,
    meta: {
      title: '往期活动'
    }
  },
  {
    path: '/HistoryActivityDetail',
    name: 'HistoryActivityDetail',
    component: DrawHistoryActivityDetail,
    meta: {
      title: '活动详情'
    }
  },
  {
    path: '/drawrule',
    name: 'drawrule',
    component: DrawRule,
    meta: {
      title: '抽奖规则'
    }
  },
  {
    path: '/adduser',
    name: 'adduser',
    component: AddUser,
    meta: {
      title: '添加人员'
    }
  },
  {
    path: '/infomanagement',
    name: 'infomanagement',
    component: InfoManagement,
    meta: {
      title: '网吧信息管理'
    }
  },
  {
    path: '/searchmap',
    name: 'searchmap',
    component: SearchMap,
    meta: {
      title: '查找经纬度'
    }
  },
  {
    path: '/evaluation',
    name: 'evaluation',
    component: Evaluation,
    meta: {
      title: '评价'
    }
  },
  {
    path: '/xjEvaluation',
    name: 'xjEvaluation',
    component: XjEvaluation,
    meta: {
      title: '评价'
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: Agreement,
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/workorderprocess',
    name: 'workorderprocess',
    component: WorkOrderProcess,
    meta: {
      title: '工单处理'
    }
  },
  {
    path: '/workOrderdetails',
    name: 'workOrderdetails',
    component: WorkOrderDetails,
    meta: {
      title: '工单详情'
    }
  },
  {
    path: '/processmethod',
    name: 'processmethod',
    component: ProcessMethod,
    meta: {
      title: '处理完毕'
    }
  },
  {
    path: '/customerinfo',
    name: 'customerinfo',
    component: CustomerInfo,
    meta: {
      title: '网吧名称'
    }
  },
  {
    path: '/base',
    name: 'base',
    component: Base,
    meta: {
      title: '知识库'
    }
  },
  {
    path: '/baseserch',
    name: 'baseserch',
    component: BaseSerch,
    meta: {
      title: '知识库'
    }
  },
  {
    path: '/basesearchdetails',
    name: 'basesearchdetails',
    component: BaseSearchDetails,
    meta: {
      title: '问题详情'
    }
  },
  {
    path: '/inspectionrecords',
    name: 'inspectionrecords',
    component: InspectionRecords,
    meta: {
      title: '巡检记录'
    }
  },
  {
    path: '/inspectionrecordsdetails',
    name: 'inspectionrecordsdetails',
    component: InspectionRecordsDetails,
    meta: {
      title: '巡检详情'
    }
  },
  {
    path: '/writeinspectionrecords',
    name: 'writeinspectionrecords',
    component: Writeinspectionrecords,
    meta: {
      title: '填写巡检单'
    }
  },
  {
    path: '/searchinternetcafes',
    name: 'searchinternetcafes',
    component: SearchInternetCafes,
    meta: {
      title: '选择网吧'
    }
  },
  {
    path: '/customersearch',
    name: 'customersearch',
    component: CustomerSearch,
    meta: {
      title: '客户管理'
    }
  },
  {
    path: '/customernote',
    name: 'customernote',
    component: CustomerNote,
    meta: {
      title: '添加备注'
    }
  },
  {
    path: '/customeruser',
    name: 'customeruser',
    component: CustomerUser,
    meta: {
      title: '人员管理'
    }
  },
  {
    path: '/devoffline',
    name: 'devoffline',
    component: Devoffline,
    meta: {
      title: '设备离线'
    }
  },
  {
    path: '/zxconsultation',
    name: 'zxconsultation',
    component: Zxconsultation,
    meta: {
      title: '咨询详情'
    }
  },
  {
    path: '/notification',
    name: 'notification',
    component: Notification,
    meta: {
      title: '通知通报'
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

export default router